import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Box,
  Typography,
  IconButton,
} from '@mui/material';
import {
  Close as CloseIcon,
} from '@mui/icons-material';

import MultipartFileUpload from './MultipartFileUpload';
import {
  harmonateDialogPaperProps,
  harmonateDialogTitleSx,
  harmonateDialogCloseIconSx,
  harmonateDialogContentSx,
} from '../../../theme/harmonateStyles';

const FileUploadDialog = ({ open, onClose, onUploadComplete }) => {
  const handleCloseDialog = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleCloseDialog}
      fullWidth
      maxWidth="lg"
      PaperProps={{ ...harmonateDialogPaperProps, sx: { ...harmonateDialogPaperProps.sx, maxHeight: '95vh' } }}
    >
      <DialogTitle sx={harmonateDialogTitleSx}>
        <Box>
          <Typography variant="h6" component="div" sx={{ fontWeight: 700, color: 'inherit' }}>
            File Upload
          </Typography>
        </Box>
        <IconButton aria-label="close" onClick={handleCloseDialog} sx={harmonateDialogCloseIconSx}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ ...harmonateDialogContentSx, p: 0, pt: '0 !important' }}>
        <MultipartFileUpload 
          onClose={handleCloseDialog}
          onUploadComplete={onUploadComplete}
        />
      </DialogContent>
    </Dialog>
  );
};

export default FileUploadDialog;
